import { Link } from "react-router-dom";
import { Gem, Landmark, Building2, Scale, Briefcase, ArrowUpRight } from "lucide-react";
import { SectionHead } from "@/components/site/SectionHead";

const AUDIENCES = [
  { icon: Gem, title: "Luxury Homeowners", desc: "Estates valued at $1.5M and above.", to: "/topics/luxury-residential" },
  { icon: Landmark, title: "HOA & Condo Boards", desc: "Shared assets and fiduciary decisions.", to: "/topics/hoa-condominium" },
  { icon: Building2, title: "Commercial Owners", desc: "Portfolios, tenants, and liability.", to: "/topics/commercial-property" },
  { icon: Scale, title: "Attorneys", desc: "Defensible, exhibit-ready files.", to: "/topics/legal-documentation" },
  { icon: Briefcase, title: "Business Operators", desc: "Cybersecurity and AI readiness.", to: "/topics/business-operations" },
];

export const WhoWeServe = () => (
  <section id="who-we-serve" className="relative py-20 sm:py-24 md:py-32 btr-bg-charcoal overflow-hidden" data-testid="who-we-serve-section">
    <div className="absolute inset-0 btr-grid opacity-20 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-6">
      <SectionHead badge="Who We Serve" title={<>Built for those who <span className="text-[#a2020b]">cannot afford</span> uncertainty.</>} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4 mt-12">
        {AUDIENCES.map((a, i) => {
          const Icon = a.icon;
          return (
            <Link key={a.title} to={a.to} className="btr-reveal group btr-glass rounded-lg p-6 hover:border-[#a2020b]/50 transition-colors" style={{ transitionDelay: `${i * 50}ms` }} data-testid={`audience-card-${i}`}>
              <div className="flex items-center justify-between">
                <Icon className="w-5 h-5 text-[#a2020b]" strokeWidth={1.5} />
                <ArrowUpRight className="w-4 h-4 text-zinc-600 group-hover:text-[#a2020b] transition-colors" />
              </div>
              <div className="font-display font-bold text-white text-base mt-5">{a.title}</div>
              <div className="font-body text-zinc-400 text-sm mt-2 leading-relaxed">{a.desc}</div>
            </Link>
          );
        })}
      </div>
    </div>
  </section>
);
